// extracted by mini-css-extract-plugin
export default {"wrapper":"kM49J2tVQMtFXbxQWyvI"};